<template>
    <div class='view view--product'>
        <div class='view__content' data-scroll-section>
            <transition name='vue-fade'>
                <Spinner
                    v-if='!product'
                    :variants='["large", "fixed"]'
                />

                <ProductTier
                    v-else
                    id='product'
                    :product='product'
                    :features='features'
                    :linkedProducts='linkedProducts'
                    :ctaTextOverride='ctaTextOverride'
                    :ctaUrlOverride='ctaUrlOverride'
                    :ctaTextOverrideAlways='ctaTextOverrideAlways'
                    :ctaHideIfSoldout='ctaHideIfSoldout'
                    :downloadableType='downloadableType'
                    :downloadableFile='downloadableFile'
                    :waitlistId='waitlistId'
                    :sizeChart='sizeChart'
                    :cartNotice='cartNotice'
                    data-scroll-id='product'
                    data-scroll
                />
            </transition>
        </div>

        <div data-scroll-section>
            <transition name='vue-fade-delay'>
                <Footer v-if='product' id='footer' data-scroll-id='footer' data-scroll />
            </transition>
        </div>
    </div>
</template>


<script>
import Spinner from '^/components/elements/Spinner.vue'
import ProductTier from '^/components/tiers/ProductTier.vue'
import Footer from '^/components/Footer.vue'

export default {
    name: 'ProductView',
    props: {
        slug: {
            type: String,
            required: true
        }
    },
    data: () => ({
        product: null,
        features: [],
        linkedProducts: [],
        ctaTextOverride: '',
        ctaTextOverrideAlways: false,
        ctaHideIfSoldout: false,
        downloadableType: '',
        downloadableFile: '',
        waitlistId: '',
        sizeChart: null,
        cartNotice: '',
    }),
    created () {
        fetch(`/products/${this.slug}?view=json`).then(response => {
            return response.json()
        }).then(data => {
            this.product = data.product
            this.features = data.features || []
            this.linkedProducts = data.linked_products || []
            this.ctaTextOverride = data.cta_text_override || this.ctaTextOverride
            this.ctaUrlOverride = data.cta_url_override || this.ctaUrlOverride
            this.ctaTextOverrideAlways = data.cta_text_override_always || this.ctaTextOverrideAlways
            this.ctaHideIfSoldout = data.cta_hide_if_soldout || this.ctaHideIfSoldout
            this.downloadableType = data.downloadable_type || this.downloadableType
            this.downloadableFile = data.downloadable_file || this.downloadableFile
            this.waitlistId = data.waitlist_id || this.waitlistId
            this.sizeChart = data.size_chart || null
            this.cartNotice = data.cart_notice || this.cartNotice
        })
    },
    components: {
        Spinner,
        ProductTier,
        Footer
    }
};
</script>
